// extracted by mini-css-extract-plugin
var _1 = "GretaAIChatChatListPlaceholder-moduleplaceholder__PN8mD";
var _2 = "GretaAIChatChatListPlaceholder-moduleplaceholderText__t0dqd";
var _3 = "GretaAIChatChatListPlaceholder-moduleplaceholderTitle__hIdSL";
export { _1 as "placeholder", _2 as "placeholderText", _3 as "placeholderTitle" }
